import { Box } from '@mui/material'
import { MItem } from '../Menu'
import PlaningToolRoot from '../PlaningToolRoot'
import LatestInquiriesModule from './LatestInquiriesModule'

export default function LatestInquiriesPage() {
  return (
    <PlaningToolRoot
      standalone
      menuItem={MItem.dashboardDemo}
      mainContentClass="LatestInquiriesPage flex flex-column"
    >
      <div className="contentHeader">
        <h2>Letzte Anfragen</h2>
      </div>
      <Box sx={{ padding: 2 }}>
        <LatestInquiriesModule variant="full" />
      </Box>
    </PlaningToolRoot>
  )
}
